import { Apartment } from 'modules/order/types';

const prepareApartmentsDropdownData = (apartments: Apartment[] | undefined) => {
    if (!apartments?.length) return [];
    const sorted = apartments.sort((a, b) => (a.name < b.name ? -1 : 1));
    return sorted.map(a => ({ label: a.name, value: a.id }));
};

export default prepareApartmentsDropdownData;
